module.exports = __webpack_public_path__ + "img/left.30269e91.png";